<template>
    <Modal :footer-hide="true" :mask-closable="false" v-model="show" :width="1000" >
        <table class="QHtable" v-if="show">
          <tr>
                <th style="width:125px;">基本信息</th>
                <th>
                   
                </th>
            </tr>
            <tr>
                <td><b>车厢名称</b></td>
                <td>{{ row.name }}</td>
            </tr>
            <tr>
                <td><b>车厢编号</b></td>
                <td>{{ row.NO }}</td>
            </tr>
            <tr>
                <td><b>车厢载量</b></td>
                <td>{{ row.specifications }}m³</td>
            </tr>
            <tr>
                <td><b>车厢长度</b></td>
                <td>{{ row.length }}m</td>
            </tr>
            <tr>
                <td><b>车厢宽度</b></td>
                <td>{{ row.width }}m</td>
            </tr>
            <tr>
                <td><b>车厢高度</b></td>
                <td>{{ row.height }}m</td>
            </tr>
            <tr>
                <td><b>运输单位</b></td>
                <td>{{ row.orgName }}</td>
            </tr>
            <tr>
                <td><b>车辆状态</b></td>
                <td>
                    <span v-if="row.status == 100">使用中</span>
                    <span v-if="row.status == 200">未使用</span>
                </td>
            </tr>
     
      <!-- GPS设备 end-->
            <tr>
                <th>资质证件</th>
                <th>
                  
                </th>
            </tr>
            <tr v-if="!row.information500">
                <td colspan="10">暂无证件资质信息</td>
            </tr>
            <tr v-for="(item, index) in row.information500" :key="index">
                <td><b>{{ $s('zizhiTypeTxt', item.zizhiType) || '其他资质' }}</b></td>
                <td>
                    <div class="flex-between">
                        <div>
                            <span class="MR5 CL5" v-if="$isYouxiaoqiNei(item.startTime, item.endTime)"><i
                                    class="MR3 iconfont icon-tongyi"></i>有效期内</span>
                            <span class="MR5 CL1" v-else><i class="MR3 iconfont icon-wenhao-quan"></i>有效期外</span>
                            <span>{{ item.name }}</span>
                            <span style="white-space: nowrap;">(有效期{{ $timeFmt(item.startTime, "YYYY年MM月DD日") }}至{{
                                $timeFmt(item.endTime,
                                    "YYYY年MM月DD日")
                            }})</span>
                        </div>
                        <div class="flex-between" style="margin-left:10px;">
                          
                            <span class="QHset" style="white-space: nowrap;" @click="$openImg($getFritImg(item.url))">
                                查看
                            </span>
                           
                        </div>
                    </div>
                </td>
            </tr>
        </table>


    </Modal>
</template>
<script>
  
  export default {
    components: {
     
    },
    // +----------------------------------------------------------------------
    // | Desc:data
    // +----------------------------------------------------------------------
    data() {
      return {
        show: false,
        isUpdate: false,
        row: {},
      };
    },
    props: {
      scene: {
        type: String,
        required: false,
        default: "sceneUsed",
      },
    },
    methods: {
      // +----------------------------------------------------------------------
      // | Desc:唤起修改
      // +----------------------------------------------------------------------
      hiPop(id) {
        this.$loading(true);
        this.$api.getBoxDetailed({ id: id }).then((res) => {
          this.$loading(false);
          if (res.code == 0) {
            this.row = res.data;
            this.show = true;
          } else {
            this.$msg(res.msg, "error");
          }
        });
      },
  
      // +----------------------------------------------------------------------
      // | Desc:刷新详情
      // +----------------------------------------------------------------------
      reDetailed() {
        this.hiPop(this.row);
        this.isUpdate = true;
      },
  
      // +----------------------------------------------------------------------
      // | Desc:清理关闭
      // +----------------------------------------------------------------------
      clearForm() {
        this.show = false;
        this.row = {};
        if (this.isUpdate) {
          this.$emit("success");
          this.isUpdate = false;
        }
      },
    },
  };
  </script>